export const sanitizeRequestSearchApiPayload = <
  T extends { countyId?: number }
>(
  search: T,
  canApplyCountyFilter: boolean
): T => (canApplyCountyFilter ? search : { ...search, countyId: undefined });